module.exports = __webpack_public_path__ + "static/media/barmak-izi.560cde86.svg";